let $postsLoadMore,
    $postsGrid,
    $postsGridFilter,
    $postsGridFilters,
    $postCatTags,
    $postTagContainer,
    postFilter;

const HIDDEN_CLASS = 'is-hidden';
const LOADING_CLASS = 'is-loading';
const ACTIVE_CLASS = 'is-active';
const OPEN_CLASS = 'is-open';

$(document).ready(function($) {

    $postsLoadMore    = $('.js-load-more-posts');
    $postsGrid        = $('.js-posts-grid');
    $postsGridFilter  = $('.js-posts-grid-filter');
    $postsGridFilters = $('.js-filters');
    $postCatTags      = $('.js-category-tag');
    $postTagContainer = $('.js-post-tags')

});

$(window).load(function() {

    postFilter = new PostFilter();

    $postCatTags.on('click', function() {
        if (!$(this).hasClass(ACTIVE_CLASS)){
            $postCatTags.removeClass(ACTIVE_CLASS);

            $(this).addClass(ACTIVE_CLASS);

            var termID = $(this).attr('data-term-id');
            // console.log('1:load new')
            postFilter.loadNew(termID);
        }
    });

    $postsLoadMore.on('click', function(event) {
        event.preventDefault();

        if(!$(this).parent().hasClass(LOADING_CLASS)) {
            $(this).parent().addClass(LOADING_CLASS);
            // console.log('1:load more')
            postFilter.loadPosts(false);
        }
    });
});

function PostFilter () {
    let currentPage = 1;
    let currentCategory = null;

    this.loadNew = function(cat) {
        currentCategory = cat;
        currentPage = 0;
        $postsGrid.addClass('is-hidden');
        this.loadingShow();
        this.loadPosts(true);
        $postTagContainer.addClass(LOADING_CLASS);
        $postsLoadMore.parent().addClass(LOADING_CLASS);
    }

    this.loadingShow = function() {
        $postsLoadMore.parent().removeClass(HIDDEN_CLASS);
    }

    this.loadPosts = function(newload) {
        let nextPage = currentPage + 1;

        if (newload) {
            // console.log("load new: page:" + nextPage + " category: " + currentCategory);
        } else {
            // console.log("load Next: page:" + nextPage + " category: " + currentCategory);
        }

        jQuery.ajax({
            url : linku_ajax_url,
            type : 'post',
            data : {
                action : 'appendPostsGrid',
                page : nextPage,
                categoryID: currentCategory
            },
            dataType: 'json',
            success : function( response ) {
                currentPage = nextPage;

                // console.log(response.meta);

                if(!response.meta.has_next) {
                    $postsLoadMore.parent().addClass(HIDDEN_CLASS);
                }

                if (newload ) {
                    $postsGrid.empty();
                }

                $postsGrid.append(response.html);
                $postsGrid.removeClass('is-hidden');

                setTimeout(function() {
                    $('.js-fadein').addClass('is-visible');
                }, 100);

                $postTagContainer.removeClass(LOADING_CLASS);
                $postsLoadMore.parent().removeClass(LOADING_CLASS);

                LayerSystem.reset();
            }
        });
    }
}
